var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4759 5.95808L3.1535 5.95808L7.66319 1.54766C8.02359 1.19519 8.02359 0.616775 7.66319 0.264303C7.57769 0.18052 7.47614 0.11405 7.36435 0.0686969C7.25256 0.0233442 7.13272 0 7.01168 0C6.89066 0 6.77081 0.0233442 6.65902 0.0686969C6.54723 0.11405 6.44568 0.18052 6.36018 0.264303L0.270253 6.22017C0.184584 6.30378 0.116617 6.4031 0.0702437 6.51243C0.0238701 6.62176 0 6.73897 0 6.85733C0 6.9757 0.0238701 7.0929 0.0702437 7.20224C0.116617 7.31157 0.184584 7.41088 0.270253 7.4945L6.36018 13.4504C6.44574 13.534 6.54731 13.6004 6.65909 13.6457C6.77088 13.691 6.89069 13.7143 7.01168 13.7143C7.13268 13.7143 7.25249 13.691 7.36428 13.6457C7.47606 13.6004 7.57763 13.534 7.66319 13.4504C7.74874 13.3667 7.81661 13.2674 7.86291 13.158C7.90922 13.0487 7.93305 12.9315 7.93305 12.8132C7.93305 12.6949 7.90922 12.5777 7.86291 12.4684C7.81661 12.3591 7.74874 12.2597 7.66319 12.176L3.1535 7.76563L13.4759 7.76563C13.9841 7.76563 14.4 7.35893 14.4 6.86185C14.4 6.36478 13.9841 5.95808 13.4759 5.95808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/backbutton.75ef1794f0365ca9211aa96071415902.svg";
export { ForwardRef as ReactComponent };